export function normalizeNumber(value) {
  if (value === null || value === undefined || value === "") return null;
  const numeric = Number(value);
  if (Number.isNaN(numeric)) return null;
  if (Number.isInteger(numeric)) {
    return String(numeric);
  }
  return numeric.toFixed(2).replace(/\.00$/, "");
}

export function numberEquals(target, value) {
  const numericTarget = Number(target);
  const numericValue = Number(value);
  if (Number.isNaN(numericTarget) || Number.isNaN(numericValue)) {
    return false;
  }
  return Math.abs(numericTarget - numericValue) < 0.01;
}

export function toNumber(value) {
  if (value === null || value === undefined || value === "") return null;
  const numeric = Number(String(value).replace(",", "."));
  return Number.isNaN(numeric) ? null : numeric;
}
